module.exports = __webpack_public_path__ + "img/pr-9.94782567.png";